import { getVideoEditionsEditListRefetchInterval } from '@app/modules/video-editions';
import { useWebAppGetCompositionsDetailEdits } from '@mi-front/api-v2';

/**
 * Lists video editor edits for a composition; refetches on an interval only while a render job is pending.
 */
export function useCompositionVideoEditionsEditsQuery(compositionId: string) {
  return useWebAppGetCompositionsDetailEdits(compositionId, {
    query: {
      refetchInterval: (query) => getVideoEditionsEditListRefetchInterval(query.state.data),
    },
  });
}
